import { urls } from "../../constants";
import { axiosService } from "../axios.service";

const dietTypeService = {
  getAll: () => axiosService.get(urls.settings.dietType).then(value => value.data),
  createDietType: (data) => axiosService.post(urls.settings.dietType, data).then((value) => value.data),
  updateById: (id, data) => axiosService.patch(`${urls.settings.dietType}/${id}`, data).then((value) => value.data),
  deleteById: (id) => axiosService.destroy(`${urls.settings.dietType}/${id}`),
};

export {
  dietTypeService
}

